import React from "react";
import Editor from "./partner/editor";
import Latest from "./partner/latest";
import Banner from "./press/banner";
import Freebotdm from "../home/freebotdm";
import Footer from "../shared/footer";
const Press = () => {
  return (
    <div>
      <Banner />
      <Editor />
      <Latest />
      <Freebotdm />
      <Footer />
    </div>
  );
};

export default Press;
